import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import DateLayout from './components/date_layout';
import ContainerComponent from '../../helpers/components/container.component';

const ChangeDateIndex = () => {
    const { token } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tt = queryParams.get('tt');

    return (
        <>
            <ContainerComponent span={16} top={20} bottom={20}>
                <DateLayout token={token} tt={tt} />
            </ContainerComponent>
        </>
    );
}

export default ChangeDateIndex;